module.exports = __webpack_public_path__ + "img/m1.9ae5469f.png";